(function($) {
	formHelper.addRule({
		form: '.form-manage-special-pricing-asset',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			},
			ERROR_MESSAGE_FOUR: function() {
				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage4);
				}
			},
			ERROR_MESSAGE_FIVE: function() {
				if(this.data.systemMessage5) {
					$('#system-message-5').html(this.data.systemMessage5);
				}
			}
		}
	});
})(jQuery);


jQuery(function initToolsManageSpecialPricingAssetAddForm($) {
	$('.add-special-pricing-asset-form').each(function(index, el) {

		var $container             = $(this);
		var form                  = $container.find('#form-add-special-pricing-asset');

		// Set the CKEDITOR WYSIWYG
		// CKEDITOR.replaceAll('do_ckeditor');
	});
});

jQuery(function initToolsManageSpecialPricingAssetEditForm($) {
	$('.edit-special-pricing-asset-form').each(function(index, el) {

		var $container             = $(this);
		var form                  = $container.find('#form-edit-special-pricing-asset');

		// Set the CKEDITOR WYSIWYG
		// CKEDITOR.replaceAll('do_ckeditor');	
	});
});

jQuery(function initEditSpecialPricingAsset($) {
	$('.edit-special-pricing-asset-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-special-pricing-asset');
		var $submitBtn             = $container.find('.btn-submit');
		var $copyBtn               = $container.find('.btn-copy');
		var $deleteBtn             = $container.find('.delete-button');

		$submitBtn.click(function() {
			$('#delete-special-pricing-asset').val('no');
			$('#spasset-status').val('edit');
			$form.submit();
		});

		$copyBtn.click(function() {
			$('#delete-special-pricing-asset').val('no');
			$('#spasset-status').val('copy');
			$form.submit();
		});

		$deleteBtn.click(function() {
			var r = confirm("Did you want to Continue?");
			if (r === true) {
			    $('#delete-special-pricing-asset').val('yes');
				$form.submit();
			}
		});
	});
});
